import React, { Component } from "react";
import {
  Button,
  Modal,
  Row,
  Col,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import "rc-steps/assets/index.css";
import "rc-steps/assets/iconfont.css";
import Steps, { Step } from "rc-steps";
import { GoPrimitiveDot } from "react-icons/go";
import NotificationSystem from "react-notification-system";
import * as Server from "../Server";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class TrackOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      activeStep: 0,
      showLoader: false,
    };
  }
  componentDidMount() {
    this.getTrackDetail();
  }

  getTrackDetail = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "logistics/web/ncs/trackOrder",
        method: "POST",
        data: {
          refno: this.props.order.items[0].refno || "FNC-DP-JKS20210111-19242",
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        let steps = [];
        let lastStep = response.detail.data[response.detail.data.length - 1];
        response.detail.data.map(
          (data) =>
            data.Status !== "OK" &&
            steps.push({
              title: (
                <Label className="h6 text-dark">
                  <b>{data.Status}</b>
                </Label>
              ),
              description: (
                <div className="h6 text-dark">
                  <div className="d-flex m-0 p-0">
                    <Label className="m-0 p-0">
                      <b>Comment:-</b>
                    </Label>
                    <p className="m-0 p-0">{data.Comment}</p>
                  </div>
                  <div className="d-flex m-0 p-0">
                    <Label className="m-0 p-0">
                      <b>Station:-</b>
                    </Label>
                    <p className="m-0 p-0">{data.Station}</p>
                  </div>
                  {data.Recipient.length > 0 && (
                    <div className="d-flex m-0 p-0">
                      <Label className="m-0 p-0">
                        <b>Recipient:-</b>
                      </Label>
                      <p className="m-0 p-0">{data.Recipient}</p>
                    </div>
                  )}
                  <div className="d-flex m-0 p-0">
                    <Label className="m-0 p-0">
                      <b>Date:-</b>
                    </Label>
                    <p className="m-0 p-0">{data.TimeStamp}</p>
                  </div>
                </div>
              ),
            })
        );
        steps.push({
          title: (
            <Label className="h6 text-dark">
              <b>Delivery</b>
            </Label>
          ),
          description:
            lastStep.Status === "OK" ? (
              <div className="h6 text-dark">
                <div className="d-flex m-0 p-0">
                  <Label className="m-0 p-0">
                    <b>Comment:-</b>
                  </Label>
                  <p className="m-0 p-0">{lastStep.Comment}</p>
                </div>
                <div className="d-flex m-0 p-0">
                  <Label className="m-0 p-0">
                    <b>Station:-</b>
                  </Label>
                  <p className="m-0 p-0">{lastStep.Station}</p>
                </div>
                {lastStep.Recipient.length > 0 && (
                  <div className="d-flex m-0 p-0">
                    <Label className="m-0 p-0">
                      <b>Recipient:-</b>
                    </Label>
                    <p className="m-0 p-0">{lastStep.Recipient}</p>
                  </div>
                )}
                <div className="d-flex m-0 p-0">
                  <Label className="m-0 p-0">
                    <b>Date:-</b>
                  </Label>
                  <p className="m-0 p-0">{lastStep.TimeStamp}</p>
                </div>
              </div>
            ) : (
              <div className="d-flex m-0 p-0 text-dark">
                <Label className="h6  m-0 p-0">
                  <b>Comment:-</b>
                </Label>
                <p className="m-0 p-0 h6">Not Delivered</p>
              </div>
            ),
        });
        let activeStep =
          lastStep.Status === "OK" ? steps.length - 1 : steps.length - 2;
        this.setState({ steps, activeStep });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Row>
          <Col>
            <Modal
              isOpen={this.props.trackOrderModel}
              toggle={(event) => this.props.toggleTrackOrderModel(event)}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.props.toggleTrackOrderModel(event)}
              >
                <Label className="ml-5">Tracking Detail</Label>
              </ModalHeader>
              <ModalBody>
                <div style={{ border: "1px solid #17517b" }}>
                  <div className=" d-flex ml-5 pl-1 pt-1 mb-0 h6 text-dark">
                    <Label>
                      <b>Resi Number:-</b>
                    </Label>
                    <Label className="float-right">
                      {this.props.order.items[0].refno || "-"}
                    </Label>
                  </div>
                  <hr className="m-0 p-0" style={{ borderColor: "#17517b" }} />
                  <div className="ml-5">
                    <Steps
                      direction="vertical"
                      status="finish"
                      current={this.state.activeStep}
                    >
                      {this.state.steps.length > 0 &&
                        this.state.steps.map((step, index) => (
                          <Step
                            key={index}
                            title={step.title}
                            description={step.description}
                            icon={
                              <GoPrimitiveDot
                                size={30}
                                style={{
                                  color:
                                    index <= this.state.activeStep
                                      ? "#17517b"
                                      : "#bfbebb",
                                }}
                                className="pr-1"
                              />
                            }
                          />
                        ))}
                    </Steps>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.props.toggleTrackOrderModel(event)}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          </Col>
        </Row>
        <NotificationSystem
          dismissible={false}
          ref={(notificationSystem) =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </div>
    );
  }
}

export default TrackOrder;
